var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHummer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1154.000000pt",
    height: "1280.000000pt",
    viewBox: "0 0 1154.000000 1280.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1280.000000) scale(0.100000,-0.100000)",
    fill: "white",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4835 12105 c-467 -382 -854 -693 -860 -691 -5 1 -96 112 -202 247 -106 134 -197 243 -204 241 -8 -2 -1912 -1316 -1937 -1337 -2 -1 64 -92 145 -201 82 -110 193 -259 247 -332 l99 -134 -24 -23 c-13 -12 -370 -305 -794 -650 -424 -345 -776 -633 -783 -639 -13 -13 -18 -36 -326 -1477 -178 -831 -196 -925 -196 -1012 0 -54 1 -97 3 -97 1 0 486 -81 1077 -179 l1075 -179 240 193 c132 106 573 462 980 789 665 536 741 595 752 579 7 -10 1213 -1633 2681 -3608 l2668 -3590 90 -3 89 -3 940 796 940 795 0 88 0 87 -2745 3500 c-1510 1924 -2745 3502 -2744 3505 1 3 378 309 839 680 461 371 837 680 836 685 -1 6 -419 607 -929 1337 l-927 1327 -90 1 -90 0 -850 -695z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHummer);
export default __webpack_public_path__ + "static/media/Hummer.0697b3b20f874bb1d7f288fa44d37787.svg";
export { ForwardRef as ReactComponent };